import React, { useEffect } from 'react'
import './ClientRepresentative.css'
import PortalHeader from '../clientNavbar/PortalHeader'

// Assets
import ClaygeePic from '../client-dashboard-assets/Claygee.png'

const ClientRepresentative = () => {

    // Ensure the page always start at the top
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    return (
        <div className='representative-wrapper'>

            <PortalHeader />

            <h1 className='representative-h1'><strong> Your FNN Representative</strong></h1>

            <div className='rep-pic-and-info'>

                <div className='rep-image-div'>
                    <img className="rep-pic" alt={`${ClaygeePic} headshot`} src={ClaygeePic} />
                </div>



                <div className='rep-name'>

                    <div>
                        <h1><strong>Claygee da Silva</strong> </h1>
                        <h2>Vice President, Product Strategy</h2>
                        <h3><strong>About Me</strong> </h3>
                        <p>
                            Claygee Da Silva is the Vice President of Product at FNN™, where she owns the product roadmap 
                            and leads customer-focused initiatives that turn FNN™’s wildfire intelligence into operational 
                            solutions for utilities and public agencies. She brings more than 20 years of experience across 
                            product services, customer success, professional services delivery, and global team leadership, 
                            with a background in enterprise data management, telecommunications, utility network management, 
                            and mission-critical distribution systems. Claygee holds a bachelor’s degree in Computer Science 
                            from Universidade Federal de Minas Gerais and combines technical expertise with a strong customer 
                            focus to support product excellence and long-term growth.
                        </p>
                    </div>

                    <div>
                        <h4><strong>Contact</strong> </h4>

                        <div className='rep-contact'>
                            <div className='mini-rep-contact'>
                                <p><strong>Email</strong></p>
                                claygeedasilva@fireneuralnetwork.com
                            </div>

                            <div className='mini-rep-contact'>
                                <p><strong>Office Hours</strong></p>
                                Monday - Friday, 9:00 AM - 5:00 PM EST <br/>
                                Available 24/7 via mobile for client support
                            </div>

                        </div>

                        <div className='mini-rep-contact'>
                            <p><strong>Phone Number</strong></p>
                            +1 (256)-616-2227
                        </div>

                        {/* <h4><strong>Additional Contact</strong> </h4>

                        <div className='mini-rep-contact'>
                            <p><strong>Email</strong></p>
                            <p>info@fireneuralnetwork.com</p>
                        </div> */}
                    </div>

                </div>

            </div>

        </div>
    )
}

export default ClientRepresentative